import styled from 'styled-components';

import * as mixin from '@wconcept/wconcept-ui/styles/mixin';

export const Anchor = styled.section`
  position: relative;
`;
